import { Component, Input } from '@angular/core';

export interface DueSoonItem {
  title: string;
  daysUntil: number;
}

@Component({
  selector: 'app-due-soon-mock',
  templateUrl: './due-soon-mock.component.html',
  styleUrls: ['./due-soon-mock.component.scss']
})
export class DueSoonMockComponent {
  @Input() heading: string = 'Due soon';
  @Input() items: DueSoonItem[] = [
    { title: '1.7 Aircraft Inspection', daysUntil: 2 },
    { title: '1.8 Medical Cert.',       daysUntil: 5 },
  ];

  daysLabel(days: number): string {
    return days === 1 ? '1 day' : `${days} days`;
  }
}
